// Copyright (C) 2023 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

import { Config } from '@react-awesome-query-builder/antd';
import asyncFetchUsers from 'components/resource-sorting-filtering/request-users';

export const config: Partial<Config> = {
    fields: {
        state: {
            label: 'State',
            type: 'select',
            operators: ['select_any_in', 'select_equals'], // ['select_equals', 'select_not_equals', 'select_any_in', 'select_not_any_in']
            valueSources: ['value'],
            fieldSettings: {
                listValues: [
                    { value: 'new', title: 'new' },
                    { value: 'in progress', title: 'in progress' },
                    { value: 'rejected', title: 'rejected' },
                    { value: 'completed', title: 'completed' },
                ],
            },
        },
        stage: {
            label: 'Stage',
            type: 'select',
            operators: ['select_any_in', 'select_equals'],
            valueSources: ['value'],
            fieldSettings: {
                listValues: [
                    { value: 'annotation', title: 'annotation' },
                    { value: 'validation', title: 'validation' },
                    { value: 'acceptance', title: 'acceptance' },
                ],
            },
        },
        dimension: {
            label: 'Dimension',
            type: 'select',
            operators: ['select_equals'],
            valueSources: ['value'],
            fieldSettings: {
                listValues: [
                    { value: '2d', title: '2D' },
                    { value: '3d', title: '3D' },
                ],
            },
        },
        assignee: {
            label: 'Assignee',
            type: 'select',
            valueSources: ['value'],
            operators: ['select_equals'],
            fieldSettings: {
                useAsyncSearch: true,
                forceAsyncSearch: true,
                asyncFetch: asyncFetchUsers,
            },
        },
        updatedDate: {
            label: 'Last updated',
            type: 'datetime',
            operators: ['between', 'greater', 'greater_or_equal', 'less', 'less_or_equal'],
        },
        type: {
            label: 'Type',
            type: 'select',
            operators: ['select_equals'],
            valueSources: ['value'],
            fieldSettings: {
                listValues: [
                    { value: 'annotation', title: 'Annotation' },
                    { value: 'ground_truth', title: 'Ground truth' },
                ],
            },
        },
        id: {
            label: 'ID',
            type: 'number',
            operators: ['equal', 'between', 'greater', 'greater_or_equal', 'less', 'less_or_equal'],
            fieldSettings: { min: 0 },
            valueSources: ['value'],
        },
    },
};

export const localStorageRecentCapacity = 10;
export const localStorageRecentKeyword = 'recentlyAppliedJobsFilters';
export const predefinedFilterValues = {
    分配给我: '{"and":[{"==":[{"var":"assignee"},"<username>"]}]}',
    未完成的: '{"!":{"or":[{"==":[{"var":"state"},"completed"]},{"==":[{"var":"stage"},"acceptance"]}]}}',
    已退回的: '{"and":[{"==":[{"var":"state"},"rejected"]}]}',
    标注中的: '{"and":[{"==":[{"var":"stage"},"annotation"]},{"or":[{"==":[{"var":"state"},"new"]},{"==":[{"var":"state"},"in progress"]}]}]}',
    审核中的: '{"and":[{"==":[{"var":"stage"},"validation"]},{"or":[{"==":[{"var":"state"},"new"]},{"==":[{"var":"state"},"in progress"]},' +
        '{"==":[{"var":"state"},"rejected"]}]}]}',
    质检中的: '{"and":[{"==":[{"var":"stage"},"inspection"]},{"or":[{"==":[{"var":"state"},"new"]},{"==":[{"var":"state"},"in progress"]}]}]}',
    质控中的: '{"and":[{"==":[{"var":"stage"},"qualityctl"]},{"or":[{"==":[{"var":"state"},"new"]},{"==":[{"var":"state"},"in progress"]}]}]}',
    验收中的: '{"and":[{"==":[{"var":"stage"},"acceptance"]},{"or":[{"==":[{"var":"state"},"new"]},{"==":[{"var":"state"},"in progress"]}]}]}',
    已完成的: '{"and":[{"==":[{"var":"state"},"completed"]},{"==":[{"var":"stage"},"acceptance"]}]}',
};
